import React, { memo, useState } from "react"
import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"
import { useStaticQuery, graphql } from "gatsby"
import PurpleSolidButton from "../../components/Buttons/PurpleSolidButton"
const OluPikselGaleri = ({text}) => {
  const [isOpen, setOpen] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(0)
  const {
    allImageSharp: { nodes },
  } = useStaticQuery(graphql`
    query DeadPixelImages {
      allImageSharp {
        nodes {
          fluid {
            originalImg
          }
          parent {
            ... on File {
              relativeDirectory
            }
          }
        }
      }
    }
  `)
  const deadPixelArray = nodes
    .filter(({ fluid, parent }) => parent.relativeDirectory === "deadpixels")
    .map(dpImage => dpImage.fluid.originalImg)
  const nextImg = () => {
    setPhotoIndex((photoIndex + 1) % deadPixelArray.length)
  }
  const prevImg = () => {
    setPhotoIndex(
      (photoIndex + deadPixelArray.length - 1) % deadPixelArray.length
    )
  }
  return (
    <>
      <div className="my-3 text-center">
        <PurpleSolidButton text={text} style={{textTransform:"capitalize"}}  onClick={() => setOpen(true)}/>
      </div>
      {isOpen && (
        <Lightbox
          mainSrc={deadPixelArray[photoIndex]}
          nextSrc={deadPixelArray[(photoIndex + 1) % deadPixelArray.length]}
          prevSrc={
            deadPixelArray[
              (photoIndex + deadPixelArray.length - 1) % deadPixelArray.length
            ]
          }
          onCloseRequest={() => setOpen(false)}
          onMovePrevRequest={() => prevImg()}
          onMoveNextRequest={() => nextImg()}
        />
      )}
    </>
  )
}
export default memo(OluPikselGaleri)
